import { selectIsLoading } from '@store/loaders'
import { ApiKeysActions } from '@store/reducers/apiKeys'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import type { ApiKeyScope } from '@/services/apiKeys'

export const useCreateApiKey = () => {
  const dispatch = useDispatch()

  const loading = useSelector(selectIsLoading('api_keys_create'))

  const [name, setName] = useState('')
  const [scope, setScope] = useState<ApiKeyScope>('read')
  const [error, setError] = useState<string | null>(null)

  const changeName = (value: string) => {
    setError(null)
    setName(value)
  }

  const changeScope = (value: ApiKeyScope) => {
    setError(null)
    setScope(value)
  }

  const create = () => {
    if (!name.trim()) {
      setError('Please enter a key name.')
      return
    }

    dispatch(ApiKeysActions.create({ name: name.trim(), scopes: [scope] }))
  }

  return { scope, error, loading, changeName, changeScope, create }
}
